import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useSystemEventsStore = defineStore('systemEvents', () => {

  const remainingTime = ref(0)
  const isShutdownVisible = ref(false)
  const shutdownMessage = ref('')

  const formattedTime = computed(() => {
    const totalSeconds = Math.floor(remainingTime.value / 1000)
    const h = Math.floor(totalSeconds / 3600)
    const m = Math.floor((totalSeconds % 3600) / 60)
    const s = totalSeconds % 60
    return [h, m, s].map(n => String(n).padStart(2, '0')).join(':')
  })

  const shutdownDisplayMessage = computed(() => {
    if (remainingTime.value <= 0 && isShutdownVisible.value) {
      return
    }
    return shutdownMessage.value.replace('%1$02d:%2$02d:%3$02d', formattedTime.value)
  })

  const showShutdown = (delay: number, text: string) => {
    remainingTime.value = delay
    shutdownMessage.value = text
    isShutdownVisible.value = true
  }

  const hideShutdown = () => {
    remainingTime.value = 0
    isShutdownVisible.value = false
    shutdownMessage.value = ''
  }

  const tick = () => {
    if (remainingTime.value > 0) {
      remainingTime.value -= 1000
    }
  }

  return {
    remainingTime,
    isShutdownVisible,
    formattedTime,
    shutdownDisplayMessage,
    showShutdown,
    hideShutdown,
    tick
  }
})
